"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const CodeShare = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "-1 1 24 22"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M20.708 13A2.284 2.284 0 0 1 23 15.273a2.284 2.284 0 0 1-2.292 2.272 2.29 2.29 0 0 1-1.82-.907l-2.349.931c.027.141.044.284.044.431 0 .147-.017.29-.044.43l2.349.932a2.29 2.29 0 0 1 1.82-.907A2.284 2.284 0 0 1 23 20.727 2.284 2.284 0 0 1 20.708 23a2.284 2.284 0 0 1-2.291-2.273c0-.027.007-.053.008-.08l-2.548-1.01a2.294 2.294 0 0 1-1.585.636A2.284 2.284 0 0 1 12 18a2.284 2.284 0 0 1 2.292-2.273c.616 0 1.172.244 1.585.638l2.548-1.011c-.001-.028-.008-.054-.008-.081A2.284 2.284 0 0 1 20.708 13zM13.924 2L18 5.96v4.699a7.635 7.635 0 0 0-4.23 1.558l-1.364-1.325-1.257 1.221 1.365 1.326a7.213 7.213 0 0 0-1.358 2.628l-.007.007a7.371 7.371 0 0 0-.26 1.903c0 1.079.245 2.1.675 3.023H3.778C2.798 21 2 20.225 2 19.273V3.727C2 2.775 2.797 2 3.778 2h10.146zm-6.33 8.892l-3.295 3.202 3.295 3.201 1.257-1.221-2.039-1.98 2.039-1.98-1.257-1.222zm5.073-8.028v4.318h4.444l-4.444-4.318z",
  fill: "none",
  fillRule: "evenodd"
}));

var _default = CodeShare;
exports.default = _default;